import { render, staticRenderFns } from "./Ethic.vue?vue&type=template&id=32101338&"
import script from "./Ethic.vue?vue&type=script&lang=js&"
export * from "./Ethic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports